(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.$;

  TimeSeriesChart.$inject = ['SensorService', 'ChartDataService', 'DateUtils', '$rootScope'];

  angular.module('app').directive('timeSeriesChart', TimeSeriesChart);

  function TimeSeriesChart(SensorService, ChartDataService, DateUtils, $root) {
    return {
      restrict: 'E',
      link: link,
      controller: ['$scope', '$element', controller],
      scope: {
        sensor: '=',
        asset: '=',
        chartOnly: '=?',
      },
      template:'<div class="panel panel-default series-panel"><header class="panel-heading"><h2 class="nowrap"><strong class="ng-binding">{{sensor.name}}</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><div style="width: 400px"><div class="row no-space"><div class="col-xs-10"><div class="row no-space"><div class="col-xs-6"><div class="form-group"><div class="input-group"><input type="text" class="form-control" readonly datetime-picker="dd-MM-yyyy HH:mm" append-to-body="true" is-open="from.open" datepicker-options="from.options" ng-change="fixDates(\'from\')" ng-click="from.open = !from.open" timepicker-options="from.options" datepicker-append-to-body="true" ng-model="from.value"></div></div></div><div class="col-xs-6"><div class="form-group"><div class="input-group"><input type="text" class="form-control" readonly datetime-picker="dd-MM-yyyy HH:mm" datepicker-append-to-body="true" append-to-body="true" is-open="to.open" datepicker-options="to.options" ng-change="fixDates(\'to\')" ng-click="to.open = !to.open" timepicker-options="to.options" ng-model="to.value"></div></div></div></div></div><div class="col-xs-2"><button class="btn btn-xs btn-primary btn-block" ng-click="refreshChart()" translate>buttons.load</button></div></div></div></div></div></header><div class="panel-body"><div class="row no-space"><div class="col-ms-12" ng-class="{\'col-lg-8\': !chartOnly}"><div class="chart"></div></div><div class="col-sm-12 col-lg-4" ng-if="!chartOnly"><div class="row no-space"><div class="col-ms-6 col-lg-6 col-md-3"><div class="indicator main"><div class="indicator-name text-muted" translate>general._indicators.last</div><div class="indicator-value">{{data.last ? data.last[1] : null | number: sensor.accuracy}} <span ng-if="sensor.unit">[{{sensor.unit}}]</span><div class="date">{{data.last ? data.last[0] : null | date: "yyyy-MM-dd HH:mm:ss"}}</div></div></div></div><div class="col-lg-6 col-ms-6 col-md-9"><div class="row no-space"><div class="col-xs-12 col-sm-4 col-ms-12 col-lg-12"><div class="indicator"><div class="indicator-name text-muted" translate>general._indicators.average</div><div class="indicator-value">{{data.average | number: sensor.accuracy}} <span ng-if="sensor.unit">[{{sensor.unit}}]</span></div></div></div><div class="col-xs-12 col-sm-4 col-ms-12 col-lg-12"><div class="indicator"><div class="indicator-name text-muted" translate>general._indicators.min</div><div class="indicator-value">{{data.min | number: sensor.accuracy}} <span ng-if="sensor.unit">[{{sensor.unit}}]</span></div></div></div><div class="col-xs-12 col-sm-4 col-ms-12 col-lg-12"><div class="indicator"><div class="indicator-name text-muted" translate>general._indicators.max</div><div class="indicator-value">{{data.max | number: sensor.accuracy}} <span ng-if="sensor.unit">[{{sensor.unit}}]</span></div></div></div></div></div></div></div></div></div><spinner show="!dataLoaded" css-class="\'body-bg\'" show-logo="true"></spinner></div>',
    };

    function link($scope, element, attrs) {
      $scope.target = element.find('.chart');
      $scope.$watch('sensor', function () {
        $scope.sensor.parameters = $scope.sensor.parameters || {};
        $scope.sensor.parameters.accuracy = $scope.sensor.parameters.accuracy || 2;

        if ($scope.sensor.type !== 'Number') {
          $scope.chartOnly = true;
        }

        refreshChart($scope, element, true);
      });

      element.on('$destroy', function () {
        let chart = $scope.chart;
        if (chart) {
          chart.dispose();
        }
        $(window).off('resize', reFlowChart);
      });

      $(window).resize(reFlowChart);

      function reFlowChart() {
        if ($scope.chart) {
          $scope.chart.resize();
        }
      }
    }

    function controller($scope, $element) {
      const toDate = new Date();
      const fromDate = new Date();

      toDate.setHours(toDate.getHours() + 1);
      fromDate.setHours(fromDate.getHours() - 11);

      $scope.from = {
        value: fromDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false,
        },
      };

      $scope.to = {
        value: toDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false,
          format: 'mm/dd/yyyy',
        },
      };

      $scope.refreshChart = function () {
        refreshChart($scope, $element);
      };

      $scope.fixDates = function (mode) {
        let from = $scope.from.value;
        let to = $scope.to.value;
        if (mode === 'from') {
          if (from >= to || DateUtils.daysBetween(from, to) >= 1) {
            to = new Date(from.getTime());
            to.setDate(to.getDate() + 1);
            $scope.to.value = to;
          }
        } else if (mode === 'to') {
          if (from >= to || DateUtils.daysBetween(from, to) >= 1) {
            from = new Date(to.getTime());
            from.setDate(from.getDate() - 1);
            $scope.from.value = from;
          }
        }
      };
    }

    function refreshChart($scope, $element, reCreate) {
      $scope.dataLoaded = false;
      createChart(
        $scope,
        function (err, data) {
          $scope.data = data;
          $scope.dataLoaded = true;
        },
        reCreate
      );
    }

    function createChart(scope, callback, reCreate) {
      const target = scope.target;
      const sensor = scope.sensor;
      const from = scope.from.value;
      let to = scope.to.value;

      SensorService.getData(sensor.id, { from: from, to: to })
        .then((data) => {
          return ChartDataService.getTimeSeriesData(sensor, data);
        })
        .then((data) => {
          if (scope.chart) {
            echarts.dispose(scope.chart);
          }

          if (!scope.chart || scope.chart.isDisposed()) {
            scope.chart = echarts.init(target[0], $root.darkMode ? 'dark' : 'default');
          }

          data.series.forEach((current, index) => {
            data.series[index] = Object.assign(
              {
                animation: false,
                type: 'line',
                symbol: 'none',
                lineStyle: { width: 2 },
              },
              current
            );
          });

          let hasData = data.series[0].data.length > 0;

          scope.chart.clear();
          scope.chart.setOption(
            Object.assign(
              {
                title: {
                  show: !hasData,
                  textStyle: {
                    color: 'grey',
                    fontSize: 14,
                    fontWeight: 'normal',
                  },
                  text: 'No data to display',
                  left: 'center',
                  top: 'center',
                },
                grid: {
                  left: 10,
                  top: 10,
                  right: 10,
                  bottom: 37,
                },
                dataZoom: [
                  {
                    show: hasData,
                    start: 70,
                    end: 100,
                    filterMode: 'weakFilter',
                    handleStyle: {
                      color: '#fff',
                      shadowBlur: 3,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                      shadowOffsetX: 1,
                      shadowOffsetY: 1,
                    },
                  },
                  {
                    show: hasData,
                    type: 'inside',
                    filterMode: 'weakFilter',
                    start: 0,
                    end: 100,
                  },
                ],
                tooltip: { trigger: 'axis' },
                calculable: true,
                xAxis: [
                  {
                    type: 'time',
                    boundaryGap: false,
                    axisLabel: { fontSize: 11 },
                    /*axisLabel: {
                formatter: (function (value) {
                  return moment(value).format('HH:mm');
                })
              }*/
                  },
                ],
                yAxis: [{ type: 'value', axisLabel: { show: false } }],
                series: data.series,
              },
              data.options
            )
          );
          scope.chart.resize();

          callback(null, {
            min: data.min,
            max: data.max,
            last: data.last,
            average: data.average,
          });
        })
        .catch(function (err) {
          console.log(err);
          callback(err, {});
        });
    }
  }
})();
